<template>
  <section class="flex-col items-center gap-6">
    <h2 id="trusted-by-title">Trusted by Industry Leaders</h2>

    <ul class="trustedBy w-4-5 flex flex-row gap-3 items-center justify-between">
      <li class="p-2" :style="{ backgroundColor: colors.trustedByCardBg, color: colors.text }"
        >
        <img src="/assets/images/partners/vertex.svg" class="img-fluid" alt="Vertex logo" />
      </li>
      <li class="p-4" :style="{ backgroundColor: colors.trustedByCardBg, color: colors.text }"
        >
        <img src="/assets/images/partners/antler.svg" class="img-fluid" alt="Antler logo"  />
      </li>
      <li class="p-4" :style="{ backgroundColor: colors.trustedByCardBg, color: colors.text }"
        >
        <img src="/assets/images/partners/dezerv.svg" class="img-fluid" alt="Dezerv logo" />
      </li>
      <li class="p-4" :style="{ backgroundColor: colors.trustedByCardBg, color: colors.text }"
        >
        <img src="/assets/images/partners/forceVentures.svg" class="img-fluid" alt="Force Ventures logo"
           />
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
import { useTheme } from "~/composables/useTheme";
const { colors } = useTheme();
</script>

<style scoped>
/* .img-fluid{
    width: 60%;
} */
.trustedBy {
  margin-top: 30px;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: space-evenly;
}

.trustedBy>li {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  height: 70px;
  width: 46%;
}

@media (min-width: 1024px) {
  .trustedBy {
    flex-wrap: wrap;
    gap: 40px;
  }

  .trustedBy>li {
    width: auto;
    height: 70px;
  }
}
</style>
